import { QueryHookOptions, useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { GroupFragment, GROUP_FRAGMENT } from "../../fragments";
import { GroupsQueryVariables } from "../../types";

export const GET_GROUPS = gql`
  query getGroups(
    $sortBy: String
    $direction: String
    $q: String
    $createdAfter: String
    $companyId: ID
  ) {
    groups(
      sortBy: $sortBy
      direction: $direction
      q: $q
      createdAfter: $createdAfter
      companyId: $companyId
    ) {
      collection {
        ...GroupFragment
      }
      metadata {
        totalCount
      }
    }
  }
  ${GROUP_FRAGMENT}
`;

export type GroupsData = { groups: { collection: GroupFragment[]; metadata } };

export default (
  options?: QueryHookOptions<GroupsData, GroupsQueryVariables>
) => {
  return useQuery<GroupsData, GroupsQueryVariables>(GET_GROUPS, options);
};
